import { useWarningModal } from "GlobalStore/warningModal";
import Modal from "@fdn/modal";
import Image from "next/image";
import PropTypes from "prop-types";

const predefineErrorToShow = (errorCode) => {
	if (errorCode === 555) {
		return {
			title: "We're sprucing up our website and preparing something exciting for you!",
			body: "We'll be right back. You can relax with a good book and sheet mask while you wait 😉",
			image: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/maintenanc.png",
		};
	}

	return {
		title: "We're sorry, something went wrong.",
		body: "Please try again later or contact our customer service if the problem persists.",
	};
};

export default function ModalWarning({ isMobile }) {
	const {
		title, body, image, code, customChildren, clearBody,
	} =		useWarningModal();
	const isShow = !!code || !!body || !!customChildren;

	const predefined = predefineErrorToShow(code);

	const finalData = {
		title: title || predefined.title,
		body: body || predefined.body,
		image: image || predefined.image,
	};

	return (
		<Modal
			is_mobile={isMobile}
			show={isShow}
			background_image="null"
			closable
			width="700px"
			on_click={clearBody}
		>
			{customChildren || (
				<>
					<div className="modal-maintenance-wrapper">
						{!!finalData.image && (
							<Image
								src={finalData.image}
								width={300}
								height={200}
								alt="maintenance"
							/>
						)}
						<div>
							<p className="fd-font-h3 fd-text-primary">
								{finalData.title}
							</p>
							<p className="fd-font-body-lg-regular fd-text-secondary">
								{finalData.body}
							</p>
						</div>
					</div>
					<style jsx>
						{`
							.modal-maintenance-wrapper {
								height: 300px;
								display: flex;
								flex-direction: column;
								align-items: center;
								justify-content: center;
								gap: 28px;
								p {
									font-size: 14px;
									text-align: center;
								}
							}
						`}
					</style>
				</>
			)}
		</Modal>
	);
}

ModalWarning.defaultProps = {
	isMobile: PropTypes.bool,
};
